<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @add="chooseOrderVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <ChooseOrderDialog
      :visible.sync="chooseOrderVisible"
      :title="'选择订单'"
      @confirm="onChooseOrderConfirm"
    />

    <ChooseRate
      :visible.sync="chooseRateOptions.visible"
      :title="'TC加价率百分比'"
      :orderCode="chooseRateOptions.orderCode"
      @confirm="onChooseRateConfirm"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderDialog from '../choose-order'
import ChooseRate from '../choose-rate'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, ChooseOrderDialog, ChooseRate },
  data() {
    return {
      usePage: true,
      chooseOrderVisible: false,
      chooseRateOptions: { visible: false, orderCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .tcOrderInfoListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChooseOrderConfirm({ orderCode }) {
      if (!orderCode) return
      this.chooseRateOptions = { visible: true, orderCode }
    },
    async onChooseRateConfirm(e) {
      this.loadingOpen()
      const res = await this.$api.tcOrderInfoAddApi(e).catch(() => null)
      this.loadingClose()

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.reload()
    },
  },
}
</script>
